import { ChevronDown, ChevronRight, FileText } from 'react-feather';

const OrderPermitsSection = ({
	orderDetails,
	sections,
	toggleSection,
	handleFileUpload,
	permitMsg,
	handlePermitSubmit,
}) => {
	if (Number(orderDetails?.status) === 1) return null;

	return (
		<div className="installation-permits">
			<div className="instalation-permits-block">
				<div
					className="title-block"
					onClick={() => toggleSection('permits')}
				>
					<h2 className="title-h2">Installation Permits</h2>
					<button type="button">
						{sections.permits ? (
							<ChevronDown size={24} />
						) : (
							<ChevronRight size={24} />
						)}
					</button>
				</div>
				{sections.permits && (
					<>
						<div className="content-box">
							{orderDetails.permits?.length > 0 && (
								<div className="permits-form thumbnails-permits">
									<p className="w-full">Click to open in a new window</p>
									{orderDetails.permits.map((permit, index) => {
										const isPdf = permit?.details?.endsWith('.pdf');
										return (
											<div key={index} className="thumbnail-permit">
												{isPdf ? (
													<a
														href={permit.details}
														target="_blank"
														rel="noopener noreferrer"
													>
														<FileText size={64} />
													</a>
												) : (
													<a
														className="thumbnail-permit-link"
														href={permit?.details}
														target="_blank"
														rel="noopener noreferrer"
													>
														<img src={permit?.details} alt="Permit" />
													</a>
												)}
											</div>
										);
									})}
								</div>
							)}
							<p>
								Please provide any permits or other documentation required
								for installation of the building.
							</p>
							<div className="permits-form">
								<input
									type="file"
									onChange={(e) => handleFileUpload(e.target.files[0])}
								/>
								<p>{permitMsg}</p>
								<button
									type="button"
									className="redBtn"
									onClick={handlePermitSubmit}
								>
									Create Permit
								</button>
							</div>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default OrderPermitsSection;
